import Header from "./components/Header";
import Content from "./components/Content";
import Projectss from "./components/Projectss.jsx";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
 
  
  
  return (
    <>

     <Router>
          <Header/>
    
    
      <Routes>
        <Route path="/" element={<Content />} />
        <Route path="/projectss" element={<Projectss />} />
      </Routes>
    </Router>
 
    
  
    </>
  );
}

export default App;
